export const COOKIE_AUTH_DATA = '_pdpa_pro_ac_'
